import { useEffect } from 'react';
import {
  prefetchNotes,
  prefetchEditor,
  prefetchInfo,
  prefetchNotebooks,
  prefetchAOF,
  prefetchNoteTabs,
} from '../utils/panelHelper';

/**
 * Hook to prefetch panel components on tab hover
 * Listens for mouseenter events on FlexLayout tabs
 */
export const useTabPrefetching = () => {
  useEffect(() => {
    const handleTabHover = (event) => {
      // Ensure event.target is a valid DOM element
      if (!event || !event.target || typeof event.target.closest !== 'function') {
        return;
      }

      const tabButton = event.target.closest('.flexlayout__tab_button');
      if (!tabButton) return;

      const tabContent = tabButton.querySelector('.flexlayout__tab_button_content');
      if (!tabContent) return;

      const tabName = tabContent.textContent?.trim().toLowerCase();
      if (!tabName) return;

      // Map tab names to prefetch functions
      const prefetchMap = {
        'notes': prefetchNotes,
        'editor': prefetchEditor,
        'info': prefetchInfo,
        'notebooks': prefetchNotebooks,
        'areas of focus': prefetchAOF,
        'open notes': prefetchNoteTabs,
      };

      // Find matching prefetch function
      for (const [name, prefetchFn] of Object.entries(prefetchMap)) {
        if (tabName.includes(name)) {
          prefetchFn();
          break;
        }
      }
    };

    // Use event delegation on the document
    document.addEventListener('mouseenter', handleTabHover, true);

    return () => {
      document.removeEventListener('mouseenter', handleTabHover, true);
    };
  }, []);
};

export default useTabPrefetching;

